export default {
  nextJob: 'Nasledujúca zákazka',
  plannedJobMetricsUnavailable: 'Metriky budú dostupné po spustení tejto zákazky.',
  previousJob: 'Predchádzajúca zákazka',
  detailsTabs: {
    events: 'Udalosti',
    images: 'Obrázky',
  },
};
